export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement1.fa2beade.png";